import I18n from 'I18n';
import Raven from 'raven-js';
import { CALL, EMAIL, LINKED_IN, LOGGED_CALL, LOGGED_EMAIL, LOGGED_LINKED_IN_MESSAGE, LOGGED_MEETING, LOGGED_POSTAL_MAIL, LOGGED_SMS, LOGGED_WHATS_APP, NOTE, SCHEDULE, TASK, ENROLLED_IN_SEQUENCE, WHATS_APP } from 'crm-activity-creator-data/interaction/InteractionTypes';
export const getTranslatedButtonAriaLabel = interactionName => {
  // This approach is avoiding dynamic translation keys to improve static analysis.
  switch (interactionName) {
    case CALL:
      return I18n.text('createActivityButtons.action.call');
    case EMAIL:
      return I18n.text('createActivityButtons.action.email');
    case LINKED_IN:
      return I18n.text('createActivityButtons.action.linked-in');
    case LOGGED_CALL:
      return I18n.text('createActivityButtons.action.logged-call');
    case LOGGED_EMAIL:
      return I18n.text('createActivityButtons.action.logged-email');
    case LOGGED_LINKED_IN_MESSAGE:
      return I18n.text('createActivityButtons.action.logged-linked-in-message');
    case LOGGED_MEETING:
      return I18n.text('createActivityButtons.action.logged-meeting');
    case LOGGED_POSTAL_MAIL:
      return I18n.text('createActivityButtons.action.logged-postal-mail');
    case LOGGED_SMS:
      return I18n.text('createActivityButtons.action.logged-sms');
    case LOGGED_WHATS_APP:
      return I18n.text('createActivityButtons.action.logged-whats-app');
    case NOTE:
      return I18n.text('createActivityButtons.action.note');
    case SCHEDULE:
      return I18n.text('createActivityButtons.action.schedule');
    case TASK:
      return I18n.text('createActivityButtons.action.task');
    case ENROLLED_IN_SEQUENCE:
      return I18n.text('createActivityButtons.action.enrolled-in-sequence');
    case WHATS_APP:
      return I18n.text('createActivityButtons.action.whats-app');
    default:
      {
        const error = new Error('Unknown interaction type received when determining Activity Creator button aria label.');
        Raven.captureException(error, {
          fingerprint: ['ERROR_BUTTON_ARIA_LABEL'],
          extra: {
            interactionType: interactionName,
            message: 'Unknown interaction type for button aria label'
          }
        });
        return I18n.text('createActivityButtons.action.unknown');
      }
  }
};
export const getTranslatedButtonLabel = interactionName => {
  // This approach is avoiding dynamic translation keys to improve static analysis.
  switch (interactionName) {
    case CALL:
      return I18n.text('createActivityButtons.label.call');
    case EMAIL:
      return I18n.text('createActivityButtons.label.email');
    case LINKED_IN:
      return I18n.text('createActivityButtons.label.linked-in');
    case LOGGED_CALL:
      return I18n.text('createActivityButtons.label.logged-call');
    case LOGGED_EMAIL:
      return I18n.text('createActivityButtons.label.logged-email');
    case LOGGED_LINKED_IN_MESSAGE:
      return I18n.text('createActivityButtons.label.logged-linked-in-message');
    case LOGGED_MEETING:
      return I18n.text('createActivityButtons.label.logged-meeting');
    case LOGGED_POSTAL_MAIL:
      return I18n.text('createActivityButtons.label.logged-postal-mail');
    case LOGGED_SMS:
      return I18n.text('createActivityButtons.label.logged-sms');
    case LOGGED_WHATS_APP:
      return I18n.text('createActivityButtons.label.logged-whats-app');
    case NOTE:
      return I18n.text('createActivityButtons.label.note');
    case SCHEDULE:
      return I18n.text('createActivityButtons.label.schedule');
    case TASK:
      return I18n.text('createActivityButtons.label.task');
    case ENROLLED_IN_SEQUENCE:
      return I18n.text('createActivityButtons.label.enrolled-in-sequence');
    case WHATS_APP:
      return I18n.text('createActivityButtons.label.whats-app');
    default:
      {
        const error = new Error('Unknown interaction type received when determining Activity Creator button label.');
        Raven.captureException(error, {
          fingerprint: ['ERROR_BUTTON_LABEL'],
          extra: {
            interactionType: interactionName,
            message: 'Unknown interaction type for button label'
          }
        });
        return I18n.text('createActivityButtons.label.unknown');
      }
  }
};
export const getTranslatedButtonAction = interactionName => {
  // This approach is avoiding dynamic translation keys to improve static analysis.
  switch (interactionName) {
    case CALL:
      return I18n.text('createActivityButtons.action.call');
    case EMAIL:
      return I18n.text('createActivityButtons.action.email');
    case LOGGED_CALL:
      return I18n.text('createActivityButtons.action.logged-call');
    case LINKED_IN:
      return I18n.text('createActivityButtons.action.linked-in');
    case LOGGED_EMAIL:
      return I18n.text('createActivityButtons.action.logged-email');
    case LOGGED_LINKED_IN_MESSAGE:
      return I18n.text('createActivityButtons.action.logged-linked-in-message');
    case LOGGED_MEETING:
      return I18n.text('createActivityButtons.action.logged-meeting');
    case LOGGED_POSTAL_MAIL:
      return I18n.text('createActivityButtons.action.logged-postal-mail');
    case LOGGED_SMS:
      return I18n.text('createActivityButtons.action.logged-sms');
    case LOGGED_WHATS_APP:
      return I18n.text('createActivityButtons.action.logged-whats-app');
    case NOTE:
      return I18n.text('createActivityButtons.action.note');
    case SCHEDULE:
      return I18n.text('createActivityButtons.action.schedule');
    case TASK:
      return I18n.text('createActivityButtons.action.task');
    case ENROLLED_IN_SEQUENCE:
      return I18n.text('createActivityButtons.action.enrolled-in-sequence');
    case WHATS_APP:
      return I18n.text('createActivityButtons.action.whats-app');
    default:
      {
        const error = new Error('Unknown interaction type received when determining Activity Creator button action translation.');
        Raven.captureException(error, {
          fingerprint: ['ERROR_BUTTON_ACTION'],
          extra: {
            interactionType: interactionName,
            message: 'Unknown interaction type for button action'
          }
        });
        return I18n.text('createActivityButtons.action.unknown');
      }
  }
};